import { RelativeSpinner } from '@components/core-ui/spinners/Spinner/RelativeSpinner';

export function Spinner(props: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className="relative h-32 inset-0 flex items-center justify-center" {...props}>
      <RelativeSpinner />
    </div>
  );
}
